// extracted by mini-css-extract-plugin
export default {"pageWrapper":"Paymant_pageWrapper__H+XfP","pageContainer":"Paymant_pageContainer__Gi1qd"};